import * as React from 'react'

import {makeEditable} from '@/common/utils'
import {ButtonVideo} from '@/components/ButtonVideo/ButtonVideo'
import {Grid} from '@/components/Grid'

const Video = ({cover, iframe, buttonLabel, _editable}) => {
  return (
    <section
      {...makeEditable(_editable)}
      className='iframe-wrapper [&_iframe]:h-full [&_iframe]:w-full'
    >
      <Grid>
        <div className='aspect-h-9 aspect-w-16 col-span-full'>
          <ButtonVideo cover={cover} buttonLabel={buttonLabel} />
          <iframe
            allowfullscreen
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            title='YouTube video player'
            frameborder='0'
            referrerpolicy='strict-origin-when-cross-origin'
            data-requires-vendor-consent='youtube'
            data-src={iframe}
            style={{
              backgroundImage: cover.filename ? `url(${cover.filename})` : 'url(/iframePlayer.png)',
              backgroundSize: 'cover',
            }}
          ></iframe>
        </div>
      </Grid>
    </section>
  )
}

export default Video
